<template>

  <div class="app" id="app" v-if="$route.path !== '/login'">

    <Loading />
    <template v-if="getBookingAcceptedStatus">
      <div class="test-mode-banner-container">
        <div class="test-mode-banner border-red">
            <div class="test-mode-banner-content bg-red">
              <span class="text-uppercase">Pending</span>
            </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="test-mode-banner-container" v-if="enviromentType && enviromentType !== 'production'">
        <div class="test-mode-banner border-orange">
            <div class="test-mode-banner-content bg-orange">
              <span class="text-uppercase">{{ enviromentType }}</span>
            </div>
        </div>
      </div>
    </template>
    
    <notifications />
    <div class="app__logo" v-if="$auth.ready()">
      Mistral Holidays
    </div>

    <div class="app__header">

      <breadcrumbs></breadcrumbs>

      <div class="app__shortcuts">

        <router-link to="/settings">
          <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.967 16H7.033a.745.745 0 0 1-.744-.673l-.199-1.188a6.411 6.411 0 0 1-1.08-.448l-.995.71a.743.743 0 0 1-.989-.06L1.66 12.973a.746.746 0 0 1-.05-1.002l.7-.981a6.394 6.394 0 0 1-.448-1.08L.656 9.709A.74.74 0 0 1 0 8.967V7.033c0-.386.29-.706.673-.744l1.188-.2c.116-.372.267-.734.448-1.079l-.71-.995a.739.739 0 0 1 .06-.988l1.368-1.368a.767.767 0 0 1 1.002-.05l.982.7a6.377 6.377 0 0 1 1.08-.448l.2-1.205A.74.74 0 0 1 7.033 0h1.934c.386 0 .706.29.745.673L9.91 1.86c.373.116.735.267 1.08.448l.995-.71a.732.732 0 0 1 .46-.159c.2 0 .387.078.528.219l1.367 1.368a.745.745 0 0 1 .051 1.002l-.7.981c.182.345.332.707.448 1.08l1.205.201a.74.74 0 0 1 .656.742v1.934c0 .387-.29.706-.674.744l-1.187.198a6.388 6.388 0 0 1-.448 1.08l.71.995a.74.74 0 0 1-.06.989l-1.368 1.367a.766.766 0 0 1-1.003.05l-.98-.7a6.386 6.386 0 0 1-1.08.448l-.201 1.206a.74.74 0 0 1-.742.656zM4.99 13.115c.044 0 .09.01.13.034.402.225.831.403 1.275.529.098.028.172.11.189.21l.227 1.37c.014.127.11.213.22.213h1.935a.22.22 0 0 0 .218-.196l.23-1.386c.017-.1.09-.183.19-.21a5.89 5.89 0 0 0 1.274-.53c.09-.05.2-.044.283.015l1.13.807c.113.092.23.073.306-.004l1.368-1.368a.218.218 0 0 0 .015-.293l-.817-1.143a.264.264 0 0 1-.016-.284c.226-.4.404-.83.53-1.274a.264.264 0 0 1 .21-.19l1.369-.228c.127-.013.214-.108.214-.22V7.034a.22.22 0 0 0-.196-.218l-1.386-.231a.265.265 0 0 1-.212-.189 5.822 5.822 0 0 0-.528-1.274.265.265 0 0 1 .015-.283l.807-1.13c.082-.101.075-.227-.004-.307l-1.368-1.368a.224.224 0 0 0-.293-.015l-1.144.818a.264.264 0 0 1-.283.015 5.876 5.876 0 0 0-1.274-.53.264.264 0 0 1-.19-.21L9.189.743C9.174.613 9.08.53 8.967.53H7.033a.218.218 0 0 0-.218.196l-.23 1.386a.264.264 0 0 1-.189.21 5.848 5.848 0 0 0-1.275.53c-.09.05-.2.044-.283-.015l-1.13-.808c-.114-.09-.23-.072-.307.005L2.033 3.401a.217.217 0 0 0-.014.292l.817 1.144c.06.084.065.194.015.284-.225.4-.403.83-.529 1.274a.264.264 0 0 1-.21.189l-1.37.228c-.129.014-.213.108-.213.221v1.934c0 .113.084.207.196.217l1.386.231c.1.017.183.09.21.189.126.442.304.871.53 1.275.05.09.044.2-.015.283l-.807 1.13c-.083.1-.076.227.004.307L3.4 13.966c.078.078.21.084.293.015l1.144-.817c.046-.033.1-.05.154-.05zm3.01-1.95A3.169 3.169 0 0 1 4.834 8 3.169 3.169 0 0 1 8 4.834 3.169 3.169 0 0 1 11.165 8 3.169 3.169 0 0 1 8 11.165zm0-5.802A2.64 2.64 0 0 0 5.363 8 2.64 2.64 0 0 0 8 10.636 2.64 2.64 0 0 0 10.637 8 2.64 2.64 0 0 0 8 5.363z"/>
          </svg>
        </router-link>

        <a @click="logout" title="logout"><svg height="16" width="15" xmlns="http://www.w3.org/2000/svg"><path d="M3.885 3.16a6.637 6.637 0 0 0-2.428 2.41 6.531 6.531 0 0 0-.886 3.287c0 3.627 2.974 6.577 6.629 6.577s6.63-2.95 6.63-6.577a6.531 6.531 0 0 0-.887-3.288 6.637 6.637 0 0 0-2.428-2.408.282.282 0 0 1-.104-.387.287.287 0 0 1 .39-.103 7.205 7.205 0 0 1 2.635 2.615c.63 1.08.964 2.315.964 3.571C14.4 12.796 11.17 16 7.2 16S0 12.796 0 8.857c0-1.256.333-2.49.964-3.571A7.207 7.207 0 0 1 3.6 2.67a.286.286 0 0 1 .39.103.282.282 0 0 1-.105.387zM6.915.284C6.915.127 7.042 0 7.2 0s.285.127.285.283v8.574c0 .157-.127.283-.285.283s-.285-.126-.285-.283z"/></svg></a>
      </div>
    </div>

    <Nav></Nav>

    <main class="main">
      <router-view></router-view>
    </main>
  </div>

    <div class="app" id="app" v-else>
        <router-view></router-view>
    </div>
</template>

<script>
  import Nav from '@/components/Nav.vue'
  import Loading from '@/components/Loading.vue'
  import {mapGetters} from 'vuex'
  export default {
    name: 'App',
    components: {
      Nav,
      Loading
    },
    data () {
      return {
        enviromentType: ''
      }
    },
    computed: {
      ...mapGetters(['getBookingAcceptedStatus'])
    },
    created() {
      this.enviromentType = process.env.VUE_APP_MODE;
    },
    methods: {
      logout() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      }
    }
  }
</script>

<style lang="scss">
@import "./assets/sass/app.scss";
.table-striped>tbody>tr {
  --bs-table-accent-bg: #FFF;
}
.table-striped>tbody>tr:hover {
  --bs-table-accent-bg: #8381813a;
  background-color: #8381813a;
}
.modal {
  display: block;
}
.color-orange {
  color: #fe8e0e !important;
  font-weight: bolder;
}
a.black_list {
  color: red !important;
  font-weight: bolder;
}
.select-checkbox {
  display: none;
}
</style>

<style scoped>
.test-mode-banner-container{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
}
.test-mode-banner{
  margin: 0;
  z-index: 6;
  text-align: center;
  pointer-events: none;
  line-height: 0;
  position: absolute;
  left: 0;
  right: 0;
}
.test-mode-banner-content {
  box-sizing: border-box;
  color: #fff;
  font-size: 12px;
  line-height: 10px;
  font-weight: bold;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 3px 8px 7px 8px;
  display: inline-block;
  position: relative;
}
.border-orange {
  border-top: 5px solid #ff8f0e;
}
.bg-orange {
  background-color: #ff8f0e;
}
.border-red {
  border-top: 5px solid #DC3545;
}
.bg-red {
  background-color: #DC3545;
}
</style>
